export default function trackABTestingStep(step: number) {
  //submits displayed step to Convert Experiments, which is located outside of the react app

  //steps are:
  // 1 = Afspraak
  // 2 = Winkel
  // 2.1 = Datum & tijd
  // 3 = Persoonsgegevens
  // 4 = Bevestigen

  //A/B testing
  if ((window as any).eBookerStep != step){ //only set if new step is different
    (window as any).eBookerStep = step; //variable is set in index.html respectively in the containing Kentico page
    (window as any)._conv_q = (window as any)._conv_q || [];
    (window as any)._conv_q.push(["run", "true"]);
  }
}